const getApiUrl = () => {
  const url = process.env.REACT_APP_API_URL;
  if (!url) {
    throw new Error("REACT_APP_API_URL is not set. Please configure in .env file.");
  }
  return url;
};

const getLicenseApiUrl = () => {
  const url = process.env.REACT_APP_LICENSE_API_URL;
  if (!url) {
    throw new Error("REACT_APP_LICENSE_API_URL is not set. Please configure in .env file.");
  }
  return url;
};

export { getApiUrl, getLicenseApiUrl };
export default getApiUrl;